/**
 * Context for seasonality. Provides two keys:
 *   year: 19|20|21|...
 *   season: F|S
 *
 * Note that we could redefine the acceptable values for these keys to accommodate
 * more seasons in the future. For example season could accept: spring, summer, fall, winter.
 */

import React from "react";
export const SeasonalContext = React.createContext({});
export const SeasonalContextProvider = ({ children, year, season }) => (
  <SeasonalContext.Provider value={{ year, season }}>{children}</SeasonalContext.Provider>
);
export const SeasonalContextConsumer = SeasonalContext.Consumer;
